import {Component} from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html'
})
/** Application footer — thin wrapper that exposes `LayoutService` to the template. */
export class AppFooterComponent {

    constructor(public layoutService: LayoutService) {}
}
